/**
 * Centralized environment configuration
 * This file provides a single source of truth for all environment variables
 * with proper typing and default values
 */

export const envConfig = {
  // Store Configuration
  storeId: process.env.NEXT_PUBLIC_STORE_ID || "",

  // Shopify Storefront API Configuration
  shopify: {
    storeDomain: process.env.NEXT_PUBLIC_SHOPIFY_STORE_DOMAIN || "",
    apiVersion: process.env.NEXT_PUBLIC_SHOPIFY_API_VERSION || "2025-04",
    storefrontAccessToken:
      process.env.NEXT_PUBLIC_SHOPIFY_STOREFRONT_ACCESS_TOKEN || "",
    adminAccessToken: process.env.SHOPIFY_ADMIN_ACCESS_TOKEN || "",
  },

  // KwikPass Configuration
  kwikpass: {
    userToken: process.env.NEXT_PUBLIC_KWIKPASS_USER_TOKEN || "",
    userCoreToken: process.env.NEXT_PUBLIC_KWIKPASS_USER_CORE_TOKEN || "",
  },

  moengage: {
    appId: process.env.NEXT_PUBLIC_MOENGAGE_APP_ID,
    shopifyStore: process.env.NEXT_PUBLIC_SHOPIFY_STORE_DOMAIN,
    scriptUrl: process.env.NEXT_PUBLIC_MOENGAGE_SCRIPT_BASE_URL,
  },

  // Judge.me Configuration
  judgeme: {
    apiToken: process.env.NEXT_PUBLIC_JUDGEME_API_TOKEN,
    shopDomain: process.env.NEXT_PUBLIC_JUDGEME_SHOP_DOMAIN || "",
  },

  // GoKwik Configuration
  gokwik: {
    environment: process.env.NEXT_PUBLIC_GOKWIK_ENVIRONMENT || "",
    type: process.env.NEXT_PUBLIC_GOKWIK_TYPE || "",
    mid: process.env.NEXT_PUBLIC_GOKWIK_MID || "",
    phoneNumber: process.env.NEXT_PUBLIC_GOKWIK_PHONE || "",
    scriptUrl: process.env.NEXT_PUBLIC_GOKWIK_SCRIPT_BASE_URL,
    bannerMessages: [
      process.env.NEXT_PUBLIC_GOKWIK_BANNER_MESSAGE_1 || "",
      process.env.NEXT_PUBLIC_GOKWIK_BANNER_MESSAGE_2 || "",
    ],
  },
};
